// Copyright (c) Docugami, Inc. All rights reserved.

import { Component, ComponentId } from "sdv/engine/Component";
import { SelectionFilters } from "sdv/SelectionFilters";

export enum TableSelectorType {
    Row,
    Column,
    Table
}

export interface TableChunkSelectorComponent extends Component {
    typeId: ComponentId.TableChunkSelector;
    selectorType: TableSelectorType;
    supportedFilters?: SelectionFilters;
    visibleRangeX?: [number, number],
    visibleRangeY?: [number, number],
    parentTableId: string;
}
